import { render, staticRenderFns } from "./reports.dashboard.view.component.vue?vue&type=template&id=6012684a&scoped=true&"
import script from "./reports.dashboard.view.component.vue?vue&type=script&lang=ts&"
export * from "./reports.dashboard.view.component.vue?vue&type=script&lang=ts&"
import style0 from "./reports.dashboard.view.component.vue?vue&type=style&index=0&id=6012684a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6012684a",
  null
  
)

export default component.exports